'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _objectSpread = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var crypto = require('libp2p-crypto');

var multihashing = require('multihashing-async');

var PeerId = require('peer-id');

var AbortController = require('abort-controller');

var errcode = require('err-code');

var times = require('p-times');

var c = require('./constants');

var _require = require('./utils'),
    logger = _require.logger;

var RandomWalk = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param {DHT} dht
   * @param {object} options
   * @param {randomWalkOptions.enabled} options.enabled
   * @param {randomWalkOptions.queriesPerPeriod} options.queriesPerPeriod
   * @param {randomWalkOptions.interval} options.interval
   * @param {randomWalkOptions.timeout} options.timeout
   * @param {randomWalkOptions.delay} options.delay
   * @param {DHT} options.dht
   */
  function RandomWalk(dht, options) {
    _classCallCheck(this, RandomWalk);

    if (!dht) {
      throw new Error('Random Walk needs an instance of the Kademlia DHT');
    }

    this._kadDHT = dht;
    this._options = _objectSpread(_objectSpread({}, c.defaultRandomWalk), options);
    this.log = logger(dht.peerInfo.id, 'random-walk');
    this._timeoutId = undefined;
  }
  /**
   * Start the Random Walk process. This means running a number of queries
   * every interval requesting random data. This is done to keep the dht
   * healthy over time.
   *
   * @returns {void}
   */


  _createClass(RandomWalk, [{
    key: "start",
    value: function start() {
      var _this = this;

      // Don't run twice
      if (this._timeoutId || !this._options.enabled) {
        return;
      } // Start doing random walks after `this._options.delay`


      this._timeoutId = setTimeout(function () {
        // Start runner immediately
        _this._runPeriodically();
      }, this._options.delay);
    }
    /**
     * Stop the random-walk process. Any active
     * queries will be aborted.
     *
     * @returns {void}
     */

  }, {
    key: "stop",
    value: function stop() {
      if (this._timeoutId) {
        clearTimeout(this._timeoutId);
        this._timeoutId = undefined;
      }

      this._controller && this._controller.abort();
    }
    /**
     * Run function `randomWalk._walk` on every `options.interval` ms
     *
     * @private
     */

  }, {
    key: "_runPeriodically",
    value: function () {
      var _runPeriodically2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this._timeoutId) {
                  _context.next = 13;
                  break;
                }

                _context.prev = 1;
                _context.next = 4;
                return this._walk(this._options.queriesPerPeriod, this._options.timeout);

              case 4:
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](1);

                this._kadDHT._log.error('random-walk:error', _context.t0);

              case 9:
                _context.next = 11;
                return new Promise(function (resolve) {
                  _this2._timeoutId = setTimeout(resolve, _this2._options.interval);
                });

              case 11:
                _context.next = 0;
                break;

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 6]]);
      }));

      function _runPeriodically() {
        return _runPeriodically2.apply(this, arguments);
      }

      return _runPeriodically;
    }()
    /**
     * Do the random walk work.
     *
     * @param {number} queries
     * @param {number} walkTimeout
     * @returns {Promise}
     *
     * @private
     */

  }, {
    key: "_walk",
    value: function () {
      var _walk2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(queries, walkTimeout) {
        var _this3 = this;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.log('start');
                this._controller = new AbortController();
                _context3.prev = 2;
                _context3.next = 5;
                return times(queries, /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(index) {
                    var id;
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _this3.log('running query %d', index);

                            _context2.prev = 1;
                            _context2.next = 4;
                            return _this3._randomPeerId();

                          case 4:
                            id = _context2.sent;

                            if (_this3._controller) {
                              _context2.next = 7;
                              break;
                            }

                            return _context2.abrupt("return");

                          case 7:
                            _context2.next = 9;
                            return _this3._query(id, {
                              timeout: walkTimeout,
                              signal: _this3._controller.signal
                            });

                          case 9:
                            _context2.next = 16;
                            break;

                          case 11:
                            _context2.prev = 11;
                            _context2.t0 = _context2["catch"](1);

                            if (!(_context2.t0 && _context2.t0.code !== 'ETIMEDOUT')) {
                              _context2.next = 16;
                              break;
                            }

                            _this3.log.error('query %d finished with error', index, _context2.t0);

                            throw _context2.t0;

                          case 16:
                            _this3.log('finished query %d', index);

                          case 17:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, null, [[1, 11]]);
                  }));

                  return function (_x3) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 5:
                _context3.prev = 5;
                this._controller = null;
                this.log('finished queries');
                return _context3.finish(5);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2,, 5, 9]]);
      }));

      function _walk(_x, _x2) {
        return _walk2.apply(this, arguments);
      }

      return _walk;
    }()
    /**
     * The query run during a random walk request.
     *
     * TODO: While query currently supports an abort controller, it is not
     * yet supported by `DHT.findPeer`. Once https://github.com/libp2p/js-libp2p-kad-dht/pull/82
     * is complete, and AbortController support has been added to the
     * DHT query functions, the abort here will just work, provided the
     * functions support `options.signal`. Once done, this todo should be
     * removed.
     *
     * @param {PeerId} id
     * @param {object} options
     * @param {number} options.timeout
     * @param {AbortControllerSignal} options.signal
     * @returns {Promise}
     *
     * @private
     */

  }, {
    key: "_query",
    value: function () {
      var _query2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(id, options) {
        var peer;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.log('query:%s', id.toB58String());
                _context4.prev = 1;
                _context4.next = 4;
                return this._kadDHT.findPeer(id, options);

              case 4:
                peer = _context4.sent;
                _context4.next = 12;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](1);

                if (!(_context4.t0 && _context4.t0.code === 'ERR_NOT_FOUND')) {
                  _context4.next = 11;
                  break;
                }

                return _context4.abrupt("return");

              case 11:
                throw _context4.t0;

              case 12:
                this.log('query:found', peer); // wait what, there was something found? Lucky day!

                throw errcode("random-walk: ACTUALLY FOUND PEER: ".concat(peer, ", ").concat(id.toB58String()), 'ERR_FOUND_RANDOM_PEER');

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 7]]);
      }));

      function _query(_x4, _x5) {
        return _query2.apply(this, arguments);
      }

      return _query;
    }()
    /**
     * Generate a random peer id for random-walk purposes.
     *
     * @returns {Promise<PeerId>}
     *
     * @private
     */

  }, {
    key: "_randomPeerId",
    value: function () {
      var _randomPeerId2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var digest;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return multihashing(crypto.randomBytes(16), 'sha2-256');

              case 2:
                digest = _context5.sent;
                return _context5.abrupt("return", new PeerId(digest));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function _randomPeerId() {
        return _randomPeerId2.apply(this, arguments);
      }

      return _randomPeerId;
    }()
  }]);

  return RandomWalk;
}();

module.exports = RandomWalk;